import { createFileRoute, Outlet, useParams } from "@tanstack/react-router";
import { CircleSpinner } from "react-spinners-kit";
import styled from "styled-components";

import DisplayError from "@/components/DisplayError";
import LangSelector from "@/components/LangSelector";
import NavBar from "@/components/NavBar";
import SaveButton from "@/components/SaveButton";
import ScrollToTop from "@/components/ScrollToTop";
import ImportExport from "@/features/import-export/ImportExport";
import Search from "@/features/search/Search";
import { useTranslations } from "@/queries/useTranslations";
import { initEditState, store } from "@/state";
import { Row } from "@/styles/stylings";
import { validateVersionSearch } from "@/urlState";

const SaveRow = styled.div`
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 10;
    background-color: white;
    padding: 5px 15px;
    box-shadow: 0 -4px 4px rgba(0, 0, 0, 0.3);
    display: flex;
    align-items: center;
    gap: 1rem;
`;

function Main() {
    const { version } = useParams({ from: "/$version" });
    const { isPending, isError } = useTranslations(version);

    if (isPending) {
        return <CircleSpinner size={48} color="#666666" />;
    }
    if (isError) {
        return <DisplayError />;
    }
    return (
        <>
            <ScrollToTop />
            <Row>
                <Search />
                <LangSelector />
            </Row>
            <ImportExport />
            <NavBar version={version} />
            <Outlet />
            <SaveRow>
                <SaveButton />
            </SaveRow>
        </>
    );
}

export const Route = createFileRoute("/$version")({
    validateSearch: validateVersionSearch,
    beforeLoad: ({ params }) => {
        store.dispatch(initEditState(params.version));
    },
    component: Main,
});
